import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

import store from '@/store';
import { UPDATE_ROUTER_LOADER } from '@/store/action_types';
// import multiguard from 'vue-router-multiguard';
// import { usePostHog } from '@/composables/posthog';
import {
  DASHBOARD_ROUTE,
  LOGIN_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  NOT_FOUND_404_ROUTE,
  ERROR_ROUTE,
  ORGANIZATIONS_ROUTE,
  NEW_ORGANIZATION_ROUTE,
  EDIT_ORGANIZATION_ROUTE,
  ORGANIZATION_DETAILS_ROUTE,
  ORGANIZATION_SCREENS_ROUTE,
  NEW_SCREEN_ROUTE,
  ORGANIZATION_USERS_ROUTE,
  ORGANIZATION_ACTIVITY_ROUTE,
  ORGANIZATION_SETTINGS_ROUTE,
  DISPLAY_ROUTE,
  TICKETS_ROUTE,
  CHAT_ROUTE,
  KODE_AI_ROUTE,
} from '@/router/routes';
import { ifNotAuthDeny } from '@/router/guards/not_auth';
import { ifAuthDeny } from '@/router/guards/auth';
import DashboardView from '@/views/Dashboard.vue';
import LoginView from '@/views/auth/Login.vue';
// import { ifNotAdminDeny } from './guards/role';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: DASHBOARD_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: DashboardView,
  },
  {
    path: '/login',
    name: LOGIN_ROUTE,
    beforeEnter: ifAuthDeny,
    component: LoginView,
  },
  {
    path: '/organizations',
    name: ORGANIZATIONS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Organizations.vue'),
  },
  {
    path: '/organizations/new',
    name: NEW_ORGANIZATION_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/New_Organization.vue'),
  },
  {
    path: '/organizations/edit/:id',
    name: EDIT_ORGANIZATION_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Edit_Organization.vue'),
  },
  {
    path: '/organizations/:id/:name',
    name: ORGANIZATION_DETAILS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Details.vue'),
  },
  {
    path: '/organizations/:id/:name/screens',
    name: ORGANIZATION_SCREENS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Screens.vue'),
  },
  {
    // Screens are created in the designer on the Screens page; this link opens it.
    path: '/organizations/:id/:name/screens/new',
    name: NEW_SCREEN_ROUTE,
    redirect: (to) => ({
      name: ORGANIZATION_SCREENS_ROUTE,
      params: to.params,
      query: { ...to.query, create: '1' },
    }),
  },
  {
    path: '/organizations/:id/:name/users',
    name: ORGANIZATION_USERS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Users.vue'),
  },
  {
    path: '/organizations/:id/:name/activity',
    name: ORGANIZATION_ACTIVITY_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Activity_Log.vue'),
  },
  {
    path: '/organizations/:id/:name/settings',
    name: ORGANIZATION_SETTINGS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/organization/Settings.vue'),
  },
  {
    path: '/display/:id',
    name: DISPLAY_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Display.vue'),
  },
  {
    path: '/tickets',
    name: TICKETS_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Tickets.vue'),
  },
  {
    // The support chat with every organization; ?organization=<id> opens one.
    path: '/chat',
    name: CHAT_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Chat.vue'),
  },
  {
    // KodeAI, the apps' help assistant: how much of Gemini's free tier it is using, live.
    path: '/kode-ai',
    name: KODE_AI_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/Kode_AI.vue'),
  },
  {
    path: '/error',
    name: ERROR_ROUTE,
    component: () => import('@/views/Error.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: NOT_FOUND_404_ROUTE,
    beforeEnter: ifNotAuthDeny,
    component: () => import('@/views/404.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// The auth guard raises the router loader on the way in; drop it once the
// navigation has settled.
router.afterEach(() => {
  store.dispatch(UPDATE_ROUTER_LOADER, false);
});

// const { posthog } = usePostHog();

// router.afterEach(() => {
//   store.dispatch(UPDATE_ROUTER_LOADER, false);
//   posthog.capture('$pageview');
// });

// router.beforeEach((to, from) => {
//   if (from.path !== to.path) {
//     posthog.capture('$pageleave');
//   }
// });

export default router;
